const scrollToSection = (id: string) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const NAV_LINKS = [
  { label: 'ホーム', id: 'home' },
  { label: '建てサポ事業', id: 'tatesapo' },
  { label: '整理収納アドバイザー事業', id: 'organizing' },
  { label: '会社概要', id: 'company' },
  { label: 'MVV', id: 'mvv' },
];

export default function Footer() {
  return (
    <footer className="bg-[#f0ece4] border-t border-stone-200">
      <div className="max-w-6xl mx-auto px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/efa98eb8908ba68c03476b0cd87b8cc5/727e2ed769ca8d328240808d09ca791a.png"
              alt="会社ロゴ"
              className="h-12 object-contain mb-2"
            />
            <p className="text-stone-700 text-sm font-bold mb-4" style={{ fontFamily: 'Noto Serif JP' }}>合同会社べごま</p>
            <p className="text-stone-500 text-sm leading-relaxed mb-5">
              住まいと暮らしのトータルサポートカンパニー。建築コンサルティングから整理収納まで、あなたの人生をデザインします。
            </p>
          </div>

          <div>
            <h4 className="font-bold text-stone-700 text-sm mb-5">
              <a id="site-navigation" href="#home">サイトナビゲーション</a>
            </h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-stone-500 hover:text-[#1e3a70] text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-stone-700 text-sm mb-5">関連サイト</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://tatesapo.jp/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 text-stone-500 hover:text-[#1e3a70] text-sm transition-colors cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs"></i>
                  </div>
                  建てサポ公式サイト
                </a>
              </li>
              <li>
                <a
                  href="https://nurse-kataduke.com/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-2 text-stone-500 hover:text-orange-500 text-sm transition-colors cursor-pointer"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs"></i>
                  </div>
                  看護師のお片づけ公式サイト
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-stone-400 text-xs">
            © 2026 合同会社べごま. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
